import axios from "axios";
const baseDomain = "https://infini8ai.herokuapp.com";
const baseURL = `${baseDomain}/`;
export default axios.create({
  baseURL,
  headers: { "Cache-Control": "no-cache", "Content-Type": "application/json" },
});
